import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
import { AiOutlineClose, AiFillGithub, AiFillLinkedin } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { Link } from "react-router-dom";

export default function MenuToggle() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div>
      <div className={`menu-content ${menuOpen ? "menu-content-active" : ""}`}>
        <Link
          to="/"
          className="menu-item"
          onClick={handleMenuToggle}
        >
          <h2>Chanantaphon</h2>
        </Link>
        <Link
          to="/about"
          className="menu-item"
          onClick={handleMenuToggle}
          style={{ borderTop: "#000 1px solid", paddingTop: 40 }}
        >
          About
        </Link>
        <Link to="/education" className="menu-item" onClick={handleMenuToggle}>
          Education
        </Link>
        <Link to="/skill" className="menu-item" onClick={handleMenuToggle}>
          Skill
        </Link>
        <Link
          to="/work"
          className="menu-item"
          onClick={handleMenuToggle}
          style={{ borderBottom: "#000 1px solid", paddingBottom: 40 }}
        >
          Work
        </Link>
        <div className="social">
          <a
            href="https://github.com/Manusea"
            target={"_blank"}
            rel="noopener noreferrer"
          >
            <AiFillGithub size={30} color="#fff" />
          </a>
          <a
            href="https://www.linkedin.com/in/chanantaphon/"
            target={"_blank"}
            rel="noopener noreferrer"
          >
            <AiFillLinkedin size={30} color="#fff" />
          </a>
          <a
            href="mailto:chanantaphon.cha@gmail.com"
            target={"_blank"}
            rel="noopener noreferrer"
          >
            <MdEmail size={30} color="#fff" />
          </a>
        </div>
      </div>

      <div className="btn-toggle">
        {menuOpen ? (
          <AiOutlineClose onClick={handleMenuToggle} />
        ) : (
          <FaBars onClick={handleMenuToggle} />
        )}
      </div>
    </div>
  );
}
